<div class="copilot-table" *ngIf="table">
  <app-copilot-table-grid
    [table]="table"
    [maxRows]="isPeopleTable ? null : inlineRowLimit"
    [showControls]="false"
  ></app-copilot-table-grid>
  <div
    class="typography-caption answer__people-note"
    *ngIf="isPeopleTable"
  >
    Per-member rows behind this answer. Open the full report for the day-level view.
  </div>
</div>
